import { SelfBillingMode } from 'src/types/enums';

export const SELF_BILLING_MODE_NAMES: Record<SelfBillingMode, string> = {
  [SelfBillingMode.None]: 'Geen',
  [SelfBillingMode.RideOverview]: 'Ritoverzicht',
  [SelfBillingMode.SelfBilling]: 'Self billing',
};

export const SELF_BILLING_MODE_VALUES = Object.values(SelfBillingMode).map((key) => ({
  key,
  name: SELF_BILLING_MODE_NAMES[key],
}));

export type SelfBillingModeItem = (typeof SELF_BILLING_MODE_VALUES)[number];

export function selfBillingModeItem(mode: SelfBillingMode): SelfBillingModeItem {
  return SELF_BILLING_MODE_VALUES.find((item) => item.key === mode) ?? SELF_BILLING_MODE_VALUES[0];
}
